var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-layout"},[_c('Header',{attrs:{"title":_vm.title,"name":_vm.name}}),_vm._v(" "),_c('Sidebar'),_vm._v(" "),_c('Tabs'),_vm._v(" "),_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }